export const environment = {
	production: false,
	// api donde se desplega dev: cobranzadigital-dev.apps.ambientesbc.com
	apiEndPointCobranza: "https://alternativafinanciera-dev.apps.ambientesbc.com",
	// URL_BASE a la cual pegan los servicios - dependiendo del ambiente
	urlServices:
		"https://filialesexterior-ext-dev.apps.ambientesbc.com/cobranza-digital/ms-edge",
	environment: "development",
  urlMaintenance_info: "https://filialesexterior-ext-dev.apps.ambientesbc.com",
  urlDynatreceSessionReplay: "",
  	diasHabiles: '#{DIAS_HABILES}#'
};
